import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import { pageRoutes } from "config/router/pageRoutes";

function Login() {
    const { isAuthenticated, signinRedirect } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if (!isAuthenticated)
            signinRedirect()
        else {
            navigate(pageRoutes.home)
        }
    }, [isAuthenticated, navigate, signinRedirect]);

    return <Navigate to={pageRoutes.root} />
}

export const Logout = () => {
    const { isAuthenticated, signoutRedirect } = useAuth()

    useEffect(() => {
        if (isAuthenticated)
            signoutRedirect()
    }, [isAuthenticated, signoutRedirect])

    return <Navigate to={pageRoutes.root} />

}

export default Login;